import { render, staticRenderFns } from "./MiniGames.vue?vue&type=template&id=6a09b7ac&scoped=true&"
import script from "./MiniGames.vue?vue&type=script&lang=js&"
export * from "./MiniGames.vue?vue&type=script&lang=js&"
import style0 from "./MiniGames.vue?vue&type=style&index=0&id=6a09b7ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09b7ac",
  null
  
)

export default component.exports